import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { ErrorService } from 'app/common/services/error.service';

@Injectable({ providedIn: 'root' })
export class CustomEndpointService {
  private http = inject(HttpClient);
  private errorService = inject(ErrorService);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;

  public update(endpoint: string, item: any): Promise<any> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http
      .put(url, item, { headers: headers })
      .toPromise();
  }

  public create(endpoint: string, item: any) {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http
      .post(url, item, { headers: headers })
      .toPromise();
  }

  public async createProjectWbs(endpoint: string) {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    try {
      return await this.http
        .post(url, { headers: headers })
        .toPromise();
    }
    catch (e) {
      this.errorService.error('Error Creating Project WBS', e);
    }
  }

  public createProjectDrillingParameters(endpoint: string) {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, { headers: headers })
      .toPromise();
  }

  public createProjectCompletionParameters(endpoint: string) {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, { headers: headers })
      .toPromise();
  }

  public patch(endpoint: string, item: any) {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .patch(url, item, { headers: headers })
      .toPromise();
  }


  public deactivate(endpoint: string) {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http
      .delete(url, { headers: headers })
      .toPromise();
  }

  public syncStandardConfigProjects(endpoint: string) {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, { headers: headers })
      .toPromise();
  }
}